import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_kids_bestsellers: FaireCategoryEntity = {
  token: "cat_kids-bestsellers",
  type: "category",
  name: "Bestsellers",
  level: 2,
  parentToken: "cat_kids-baby",
  href: "/category/kids-baby/bestsellers",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
